export default {
  items: [
    {
      name: 'Page d’accueil',
      url: '/dashboard',
      icon: 'fp-accueil',
      buyer: true
    },
    {
      name: 'Infos',
      url: '/infos',
      icon: 'fp-infos',
      children: []
    },

  ],

  itemsInfos: [
    {
      name: 'Infos',
      url: '/infos',
      icon: 'fp-infos',
      children: [
        {
          name: 'INFOS CULTURES',
          url: '/page/18'
        },
        {
          name: 'INFOS MARCHE',
          url: '/page/11'
        },
        {
          name: 'BSV PDT',
          url: '/page/4'
        },
        {
          name: 'BSV GDES CULTURES',
          url: '/page/5'
        },
        {
          name: 'INFOS REGLEMENTAIRES',
          url: '/page/7'
        },
        {
          name: 'CONSIGNES DE COLLECTE',
          url: '/page/8'
        },
        {
          name: 'TYPES DE CONTRATS CEREALES',
          url: '/page/9'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js